// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/
import * as Sentry from "@sentry/nextjs";
import { Integrations } from "@sentry/tracing";
import { ReportingObserver as ReportingObserverIntegration } from "@sentry/integrations";

const online = ENV_ISONLINE;
const isProd = ENV_ISPROD;
const dsn = "https://87224c1aac544fd6a295c07d7f18f9d1@sentry.ezbuy.com/45";
const integrations = [
	new ReportingObserverIntegration({
		// deprecation：监听过时的api
		// intervention: 浏览器对网页做的干预
		// crash: 浏览器崩溃时的行为
		types: ["deprecation"]
	}),
	new Integrations.BrowserTracing({
		beforeNavigate: (context) => {
			return {
				...context,
				name: replacePathname(location.pathname),
			};
		},
	}),
];

Sentry.init({
	serverName: "OPTIMUS_V2_SUNFLOWER",
	integrations,
	dsn,
	// Note: if you want to override the automatic release value, do not set a
	// `release` value here - use the environment variable `SENTRY_RELEASE`, so
	// that it will also get attached to your source maps
	// release: SENTRY_RELEASE ? SENTRY_RELEASE.id : NEXT_PUBLIC_COMMIT_SHA,
	tracesSampler: () => {
		return 1;
	},
	environment: online ? "online" : isProd ? "dev" : "test",
	ignoreErrors: [
		"getAttribute",
		// Heavy Ad Intervention
		"Ad was removed",
	],
	denyUrls: [
		"https://ctrlitb.rightinthebox.com/ctr_tracking.php",
		"https://bat.bing.com/bat.js",
		"https://c.go-mpulse.net",
		"https://s.go-mpulse.net/boomerang/D8XY7-ZTTUT-KNRUR-CTM7D-KLYLX",
		"boomerang/"
	],
});

function replacePathname(pathname = "") {
	if (pathname.match(/\/active\//)) {
		return "/active";
	}
	return pathname;
}
